import React, { useState, useEffect } from "react";
import { createFilter } from "react-select";
import PbxGroupService from "core/api/PbxGroupService";
import AsyncSelect from "react-select/async";
import { Label } from "reactstrap";

const OUTBOUND_OPTION = { value: null, label: "Outbound call" };

export const PbxGroupSelectorInputComponent = ({
  field,
  form: { touched, errors, setFieldValue },
  ...props
}) => {
  const [selected, setSelected] = useState(OUTBOUND_OPTION);
  const [defaultOptions, setDefaultOptions] = useState([OUTBOUND_OPTION]);

  const filterCompanies = async (inputValue) => {
    const responseData = await PbxGroupService.filterByName(inputValue);
    const options = [OUTBOUND_OPTION];

    if (responseData.model.length > 0) {
      const groupOptions = responseData.model.map((group) => ({
        value: group.id,
        label: group.name,
      }));
      options.push(...groupOptions);
    }

    return options;
  };

  const loadOptions = (inputValue, callback) => {
    setTimeout(async () => {
      var items = await filterCompanies(inputValue);
      callback(items);
    }, 1000);
  };

  const filterConfig = {
    ignoreCase: true,
    ignoreAccents: true,
    trim: true,
  };

  useEffect(() => {
    async function fetchData() {
      const initialOptions = await filterCompanies("");
      setDefaultOptions(initialOptions);

      if (field.value) {
        const pbxGroup = await PbxGroupService.get(field.value);
        setSelected({ value: field.value, label: pbxGroup.name });
      } else {
        setSelected(OUTBOUND_OPTION);
      }
    }

    fetchData();
  }, []);

  return (
    <div>
      <Label>{props.label}</Label>
      <AsyncSelect
        value={selected}
        filterOption={createFilter(filterConfig)}
        cacheOptions
        defaultOptions={defaultOptions}
        loadOptions={loadOptions}
        {...props}
        onChange={(option) => {
          setFieldValue(field.name, option?.value);
          setSelected(option ? { value: option.value, label: option.label } : OUTBOUND_OPTION)
        }}
        getOptionLabel={(option) => `${option.label}`}
        isClearable
      />
      {touched[field.name] && errors[field.name] && (
        <div className="error">{errors[field.name]}</div>
      )}
    </div>
  );
};
